import { gql } from "@apollo/client";

export const DELIVERY_AUTH_LOGIN_MUTATION = gql`
  mutation DeliveryAuthLogin($userId: String!, $password: String!) {
    DeliveryAuthLogin(userId: $userId, password: $password)
  }
`;
